import { connect } from "react-redux";
import * as templatesActions from "./actions";

function mapStateToProps(state) {
  return {
    smsTemplates: state.templates.smsTemplates,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSMSTemplates: () => {
      dispatch(templatesActions.get_sms_templates());
    },

    setSMSTemplate: (templateType, template, expectedVersion) => {
      dispatch(
        templatesActions.set_sms_template(
          templateType,
          template,
          expectedVersion,
        ),
      );
    },
  };
}

export const templatesConnector = connect(mapStateToProps, mapDispatchToProps);
